import { cloneDeep } from "lodash";
import moment from "moment";
import {
  IS_LOADING,
  DISPLAY_PDC_FORM,
  PLANNING_SELECT_EMAIL,
  SELECT_EVENT,
  SELECT_SELECTPDC,
  SELECT_SECTOR,
  PLANNING_SET_CURRENT_FILTERS,
  PLANNING_SET_KEY_FILTER_SELECTED,
  PLANNING_GET_USER_PDCSLIST,
  PLANNING_GET_TYPES_VISIT,
  PLANNING_SELECT_USER_SECTOR,
  PLANNING_SELECT_USER,
  PLANNING_GET_ALL_SECTORSLIST,
  PLANNING_SELECT_USER_PDC,
  PLANNING_SELECT_USER_TYPEVISIT,
  PLANNING_DELETE_EVENT,
  PLANNING_SEND_NEW_EVENT,
  PLANNING_MOVE_DAY_EVENTS,
  PLANNING_UPDATE_EVENT,
  PLANNING_SET_FILTERS,
  PLANNING_SET_KEY_PDC_FILTER_SELECTED,
  PLANNING_SET_KEY_SECTOR_FILTER_SELECTED,
  PLANNING_GET_AVAILABLE_DATE_RANGE,
  PLANNING_GET_EVENT_TYPES,
  PLANNING_SELECT_DATE,
  PLANNING_SET_CURRENT_DATE_RANGE,
  PLANNING_SELECT_PDC_ID
} from "./../types";

export const selectSector = sector => {
  return {
    type: SELECT_SECTOR,
    payload: sector
  };
};

export const selectPdc = pdc => {
  return {
    type: SELECT_SELECTPDC,
    payload: pdc
  };
};

export const selectPdcId = pdcId => ({
  type: PLANNING_SELECT_PDC_ID,
  payload: pdcId
});

export const selectPdcFromMap = pdc => dispatch => {
  if (!pdc || pdc.pdc_id === undefined || pdc.pdc_id === null) return;

  dispatch(selectPdc(pdc.pdc_label));
  dispatch(selectPdcId(pdc.pdc_id));
  dispatch(updatePlanningFilters("pdc_id", pdc.pdc_id));
};

export const selectEvent = event => {
  return {
    type: SELECT_EVENT,
    payload: event
  };
};

export const displayPDCForm = value => ({
  type: DISPLAY_PDC_FORM,
  value
});

export const isLoading = value => {
  return {
    type: IS_LOADING,
    payload: value
  };
};
export const setCurrentDateRange = newRange => {
  return { type: PLANNING_SET_CURRENT_DATE_RANGE, payload: newRange };
};

export const setPlanningSelectedDate = date => {
  return { type: PLANNING_SELECT_DATE, payload: date };
};
/******************** ***********************/
export function updatePlanningFilters(key, data) {
  return (dispatch, getState) => {
    const state = getState();
    const currentFilters = cloneDeep(state.planning.currentFilters) || {};
    if (key === "email") {
      currentFilters["user_email"] = data;

      dispatch({
        type: PLANNING_SELECT_EMAIL,
        payload: data
      });

      dispatch({ type: PLANNING_SELECT_USER_PDC, payload: undefined });
      delete currentFilters["pdc_id"];
      delete currentFilters["sector_label"];
      delete currentFilters["event_sous_type_label"];
      dispatch({
        type: PLANNING_SET_FILTERS,
        values: undefined,
        key: "sector_label"
      });
      dispatch({
        type: PLANNING_SET_FILTERS,
        values: undefined,
        key: "pdc_id"
      });
      dispatch({ type: PLANNING_SELECT_USER, payload: data });
      dispatch({
        type: PLANNING_SELECT_PDC_ID,
        payload: null
      });
    } else if (key === "sector_label") {
      currentFilters[key] = data;

      dispatch({ type: PLANNING_SELECT_USER_SECTOR, payload: data });
      dispatch({ type: PLANNING_SELECT_USER_PDC, payload: undefined });
      dispatch({
        type: PLANNING_SET_FILTERS,
        values: undefined,
        key: "pdc_id"
      });
      delete currentFilters["pdc_id"];
      dispatch({
        type: PLANNING_SELECT_PDC_ID,
        payload: null
      });
    } else if (key === "pdc_id") {
      currentFilters[key] = data;

      dispatch({ type: PLANNING_SELECT_USER_PDC, payload: data });
    } else {
      console.log("add type");
      currentFilters["event_sous_type_label"] = data;
      dispatch({
        type: PLANNING_SELECT_USER_TYPEVISIT,
        payload: data
      });
    }

    dispatch(setCurrentFilters(currentFilters));
    // dispatch(getPlanning({ filters: currentFilters, page: 1 }));
  };
}

export const setCurrentFilters = currentFilters => ({
  type: PLANNING_SET_CURRENT_FILTERS,
  currentFilters
});

export const setKeyFilterSelected = key => ({
  type: PLANNING_SET_KEY_FILTER_SELECTED,
  key
});

export const setKeyPdcFilterSelected = date => ({
  type: PLANNING_SET_KEY_PDC_FILTER_SELECTED,
  date
});

export const setKeySectorFilterSelected = date => ({
  type: PLANNING_SET_KEY_SECTOR_FILTER_SELECTED,
  date
});

export const getAllSectorsList = () => {
  return { type: PLANNING_GET_ALL_SECTORSLIST };
};

export const getUserPdcsFromSector = () => {
  return { type: PLANNING_GET_USER_PDCSLIST };
};

export const fetchtypesVisitList = () => {
  return { type: PLANNING_GET_TYPES_VISIT };
};

export const fetchEventTypesList = () => {
  return { type: PLANNING_GET_EVENT_TYPES };
};

export const deleteEvent = event => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: PLANNING_DELETE_EVENT,
      event
    });
    dispatch(updatePlanningFilters("email", state.planning.selectedEmail));
  };
};

export const sendNewEvent = event => {
  console.log("event in planningActions --> ", event);
  return (dispatch, getState) => {
    // const state = getState();
    dispatch({
      type: PLANNING_SEND_NEW_EVENT,
      event
    });
    // dispatch(updateFilters("email", state.planning.selectedEmail));
  };
};

export const sendUpdatedEvent = (event, updateMethod) => ({
  type: PLANNING_UPDATE_EVENT,
  event,
  updateMethod
});

export const moveDayEvents = (sourceDate, targetDate) => ({
  type: PLANNING_MOVE_DAY_EVENTS,
  sourceDate,
  targetDate
});

export const getAvailableDateRange = () => ({
  type: PLANNING_GET_AVAILABLE_DATE_RANGE
});



// WEBPACK FOOTER //
// src/redux/actions/planningActions.js